<template>
  <div class="income-plan-push-btn">
    <a-button type="primary" :disabled="disabled" :loading="loading" @click="handlePush">
      {{ text || $t('下推收益成本确认单') }}
    </a-button>

    <!-- 下推结果弹窗 -->
    <a-modal
      :title="$t('下推成功')"
      v-model="resultVisible"
      :maskClosable="false"
      @cancel="resultVisible = false"
      width="600px"
    >
      <div v-if="confirmSnList.length > 0">
        <p class="result-tip">{{ $t('已生成以下收益成本确认单：') }}</p>
        <div class="sn-list">
          <div v-for="(sn, index) in confirmSnList" :key="index" class="sn-item">
            <a-icon type="file-text" class="mr6" />
            <a class="sn-link" @click="openConfirmDetail(sn)">{{ sn }}</a>
          </div>
        </div>
      </div>
      <div v-else class="empty-tip">{{ $t('下推成功，暂无生成单据') }}</div>
      <template slot="footer">
        <a-button type="primary" @click="resultVisible = false">{{ $t('关闭') }}</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'

export default {
  name: 'IncomePlanPushBtn',
  props: {
    // 需要下推的计划，[{ planId, allocationIdList }]
    pushList: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      resultVisible: false,
      confirmSnList: [],
    }
  },
  methods: {
    handlePush() {
      const list = (this.pushList || []).filter(
        (item) => item.planId && (item.allocationIdList || []).length > 0
      )
      if (list.length === 0) {
        this.$message.warning(this.$t('请选择需要下推的分摊明细'))
        return
      }
      if (!this.$confirm) {
        this.doPush(list)
        return
      }
      this.$confirm({
        title: this.$t('确认操作'),
        content: this.$t('是否确认下推收益成本确认单？'),
        onOk: () => this.doPush(list),
      })
    },
    async doPush(list) {
      this.loading = true
      const snList = []
      try {
        for (const item of list) {
          const res = await http({
            url: api.pushIncomePlan,
            type: 'post',
            data: {
              planId: item.planId,
              allocationIdList: item.allocationIdList,
            },
          })
          const sns =
            res?.result?.incomeCostConfirmOrderSnList ||
            res?.result?.income_cost_confirm_order_sn_list ||
            []
          sns.forEach((sn) => {
            const value = typeof sn === 'string' ? sn : sn?.sn || sn?.orderSn
            if (value) {
              snList.push(value)
            }
          })
        }
        this.confirmSnList = snList.filter(Boolean)
        this.resultVisible = true
        this.$emit('success')
      } finally {
        this.loading = false
      }
    },
    openConfirmDetail(sn) {
      if (!sn) return
      window.open(
        `/receivableManage/incomeCostConfirmDetail?sn=${encodeURIComponent(sn)}`,
        '_blank'
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.result-tip {
  color: #555;
  margin-bottom: 12px;
  font-size: 14px;
}
.sn-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.sn-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 4px;
  background: #f5f7fa;
}
.sn-link {
  color: #1890ff;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    color: #40a9ff;
    text-decoration: underline;
  }
}
.empty-tip {
  text-align: center;
  color: #999;
  padding: 20px 0;
}
</style>
